// src/components/Control/ControlPanel/Cam2Obstacle.tsx
// Зоны препятствий по камере 2 (robot/<id>/cam2/obstacle, публикует fleet_adapter):
//   {"obstacle": bool, "valid": bool, "source": "esp"|"rpi",
//    "zones": {"left"|"center"|"right": {"blocked": bool, "free": 0..1}}}
// free — насколько свободна зона: 0 — препятствие у самого низа кадра (вплотную), 1 — чисто.
// Данные — из общей телеметрии страницы.
import React from 'react';
import { useTelemetryState } from '../robot/RobotContext';
import { STALE, fresh } from '../robot/telemetry';
import { useTick } from '../../../hooks/useTick';

const ZONES: ['left' | 'center' | 'right', string][] = [['left', 'слева'], ['center', 'центр'], ['right', 'справа']];

const Cam2Obstacle: React.FC<{ compact?: boolean }> = ({ compact }) => {
  useTick(1000);
  const { msg, at } = useTelemetryState(t => ({ msg: t.obstacle, at: t.obstacleAt }));
  const ok = msg && fresh(at, STALE.obstacle) && msg.valid !== false && msg.enabled !== false;

  return (
    <div className={`op-zones ${compact ? 'compact' : ''}`}>
      <div className="op-zones-row">
        {ZONES.map(([key, label]) => {
          const z = ok ? msg!.zones[key] : null;
          const cls = !z ? 'none' : z.blocked ? 'blocked' : z.free < 0.8 ? 'near' : 'clear';
          return (
            <div key={key} className={`op-zone ${cls}`}>
              {label} {z ? `${Math.round(z.free * 100)}%${z.blocked ? ' ■' : ''}` : '—'}
            </div>
          );
        })}
      </div>
      {!compact && (
        <div className={`op-zones-text ${ok && msg!.obstacle ? 'bad' : ''}`}>
          {!ok
            ? 'Препятствия: нет данных (детекция выключена или камера 2 не на связи)'
            : `${msg!.obstacle ? 'Препятствие впереди' : 'Впереди свободно'} · детекция на ${msg!.source === 'rpi' ? 'Pi' : 'ESP'}${msg!.floor_fixed ? ' · пол откалиброван' : ''}`}
        </div>
      )}
    </div>
  );
};

export default Cam2Obstacle;
